/**
 * Decides whether the contextual modal should auto-close itself after
 * the merchant completes the underlying action (e.g. connected Stripe
 * on the integrations page → predicate flips → modal goes away).
 *
 * Pure transition rule: close on `false → true`. Don't close just because
 * the modal opened on a task that was already complete (the modal
 * shouldn't have rendered in that case, but defensively we don't auto-close).
 */
export function shouldAutoCloseContextualModal(args: {
  previousTaskComplete: boolean;
  currentTaskComplete: boolean;
}): boolean {
  return !args.previousTaskComplete && args.currentTaskComplete;
}
